<template>
  <el-form ref="ff" v-loading="loading" :model="formdata" label-width="80px">
    <el-form-item label="旧密码" prop="OldPassword" required>
      <el-input type="password" v-model="formdata.OldPassword" placeholder="输入旧密码" />
    </el-form-item>
    <el-form-item label="新密码" prop="NewPassword" required>
      <el-input type="password" v-model="formdata.NewPassword" placeholder="输入新密码" />
    </el-form-item>
    <el-form-item>
      <el-button type="danger" @click="onSubmit">保存密码</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      formdata: {},
    }
  },
  props: {
    layerid: { type: String, default: null },
  },
  methods: {
    onSubmit () {
      this.$refs['ff'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$apis.system.user.setPassword(this.formdata).then(() => {
            this.loading = false
            this.$layer.close(this.layerid)
            this.$alert('需要从新登录系统后生效！', '密码修改成功', {
              center: true,
              callback: () => {
                this.$router.replace({ path: '/login' })
              },
            })
          }).catch((e) => {
            this.$message.error(e || "操作错误")
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
  },
}
</script>
